export default "__VITE_ASSET__jTdSqmSO__"